/**
 * Bootstrap app in correct order to correctly leverage config and appEvents.
 *
 * This file should only be consumed by `./src/index.tsx`
 */
import appEvents from "./utils/appEvents";
// These are core libs which need to load after the config
// and before the brand's bootstrap
import "./utils/language";
import "./utils/i18n";
import "./utils/api";
import { AppConfig } from "./types";
import { bootstrap as bootstrapGoogleAnalytics } from "./utils/googleAnalytics";
import { bootstrap as bootstrapGoogleMaps } from "./utils/googleMaps";
import { AppState } from "./hooks/useAppState";
import { get } from "./utils/helpers";

// Fire the app's initialised event
export function bootstrap(config: AppConfig, appState: AppState) {
  bootstrapGoogleAnalytics(config);
  bootstrapGoogleMaps(appState.config, get(appState, "language"));
  appEvents.trigger("app.initialised", config);
}
